import FixedPlugin from "components/fixedPlugin/FixedPlugin";
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes.js";
import PanelBar from "views/panel/components/PanelBar";
import PanelLogout from "views/panel/components/PanelLogout";
import PanelBanner from "components/banners/PanelBanner";
import PanelBreadcrumbs from "components/breadcrumbs/panelbreadcrumbs";
import { getRoutes } from "../../utils/index";
import ReleaseVersion from "components/footer/ReleaseVersion";

export default function Panel(props) {
  const { ...rest } = props;
  
  document.documentElement.dir = "ltr";
  return (
    <div className="relative flex h-full w-full">    
      <FixedPlugin />  
      <div className="flex h-full w-full justify-center bg-[#f7faf7]">
        <main className={`panel-main-wrapper`}>
          <div className="h-full">
            <div className="border-b border-gray-100 bg-white">
              <div className="mx-auto flex max-w-7xl items-center justify-between gap-6">
                <PanelBanner/>
                <PanelBar {...rest}/>  
              </div>
            </div>
            <div className="pt-2 mx-auto mb-auto h-full min-h-[60vh] p-2 md:pr-2">
              <PanelBreadcrumbs />
              <Routes>
                {getRoutes(routes, '/panel')}

                <Route
                  path="/"
                  element={<Navigate to="/panel/services" replace />}
                />
              </Routes>
            </div>
            <PanelLogout/>
            <div className="p-3"></div>
          </div>
        </main>
      </div>
    </div>
  );
}
